import { IDropdown } from "@models/dropdown.model";
import { Organization } from "@models/organization.model";
import { User } from "@models/user.model";
import { createReducer, on } from "@ngrx/store";
import { UserAdminActions } from "@store/actions/user-admin/user-admin.actions";

export const userAdminFeatureKey = "userAdmin";

export interface State {
  users: User[];
  originalEmail: string;
  isSaveDisabled: boolean;
  roleDropdown: IDropdown[];
  organizationDropdown: Organization[];
  roleSearch: string;
  orgSearch: string;
  isLoading: boolean;
  page: number;
  itemsPerPage: number;
  isOrgsLoading: boolean;
  isRolesLoading: boolean;
  totalItems: number;
  errorMessage: string;
  userSearch: string;
}

export const initialState: State = {
  users: [],
  originalEmail: '',
  isSaveDisabled: false,
  roleDropdown: [],
  organizationDropdown: [],
  roleSearch: "",
  orgSearch: "",
  isLoading: true,
  page: 0,
  itemsPerPage: 5,
  isOrgsLoading: true,
  isRolesLoading: true,
  totalItems: 0,
  errorMessage: '',
  userSearch: '',
};

export const reducer = createReducer(
  initialState,
  on(UserAdminActions.pageLoaded, (state, action) => ({
    ...state,
  })),
  on(UserAdminActions.getOrganizationsSuccess, (state, action) => ({
    ...state,
    organizationDropdown: action.orgs,
  })),
  on(UserAdminActions.getRolesSuccess, (state, action) => ({
    ...state,
    roleDropdown: action.roles,
  })),
  on(UserAdminActions.getUsersSuccess, (state, action) => {
    return {
      ...state,
      users: action.users,
      totalItems: action.users.length,
    };
  }),
  on(UserAdminActions.addUser, (state, action) => ({
    ...state,
    isSaveDisabled: true,
  })),
  on(UserAdminActions.addUserSuccess, (state, action) => ({
    ...state,
    users: [...state.users, action.user],
    isSaveDisabled: false,
  })),
  on(UserAdminActions.addUserFailure, (state, action) => ({
    ...state,
    isSaveDisabled: false,
  })),
  on(UserAdminActions.updateUser, (state, action) => ({
    ...state,
    isSaveDisabled: true,
  })),
  on(UserAdminActions.updateUserSuccess, (state, action) => {
    const updatedUsers = state.users.map((user) =>
      action.user.id === user.id ? action.user : user
    );
    return {
      ...state,
      users: updatedUsers,
      isSaveDisabled: false
    };
  }),
  on(UserAdminActions.updateUserFailure, (state, action) => ({
    ...state,
    isSaveDisabled: false,
  })),
  on(UserAdminActions.deleteUserSuccess, (state, action) => ({
    ...state,
    users: state.users.filter((user) => user.id !== action.userId),
  })),
  on(UserAdminActions.updateIsLoading, (state, action) => ({
    ...state,
    isLoading: action.isLoading,
  })),
  on(UserAdminActions.setOriginalEmailForEdit, (state, action) => ({
    ...state,
    originalEmail: action.email,
  })),
);
